import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {
    setForceRefreshDclActive,
    setSelectedDcl
} from "../../../../_reducers/DataPanel/Dcl/dclSlice";
import {useTranslation} from "../../../../hooks/useTranslation";

const CorrelateDclSaleModal = ({show, setShow, dcl}) => {
    const {t} = useTranslation();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loader, setLoader] = useState(false);
    const [searchLoader, setSearchLoader] = useState(false);
    const [selectedSale, setSelectedSale] = useState({});
    const [requestData, setRequestData] = useState({
        date_from: moment().subtract(1, "month").format("DD/MM/YYYY"),
        date_to: moment().format("DD/MM/YYYY"),
        year: Number(moment().format("YYYY")),
        page: 1});
    const [responseData, setResponseData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalEntries, setTotalEntries] = useState(0);
    const [pageChanged, setPageChanged] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
       if(show) {
            setSelectedSale({});
            fetchSales(false);
        }
    }, [show]);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchSales(true);
        }
    }, [pageChanged]);

    const correlateDcl = () => {
        setLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/dcl/correlate-dcl`,
            {dcl: dcl?._id, sale: selectedSale?._id, company: company.id},
            {headers: { "Content-Type": "application/json" }}
        ).then((res) => {
            setLoader(false);
            if (res.data.status === "200") {
                toast.success("Επιτυχής Συσχέτιση Παραστατικού!");
                dispatch(setSelectedDcl(res.data.data));
                dispatch(setForceRefreshDclActive(true));
                setShow(false);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchSales = (fromPagination = false) => {
        if (!fromPagination) setRequestData({...requestData, page: 1});
        setSearchLoader(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/dcl/sales-search-data`,
            {
                clientName: dcl?.clientName,
                vatNumber: dcl?.clientVatNumber,
                company: company.id,
                ...requestData,
                page: fromPagination ? requestData.page : 1,
            },
            {headers: { "Content-Type": "application/json" }}
        ).then((res) => {
            setSearchLoader(false);
            if (res.data.status === "200") {
                setResponseData(res.data.data?.data);
                setTotalPages(res.data.data.totalPages);
                setTotalEntries(res.data.data.totalItems);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            setSearchLoader(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        if (type === "db") {
            if (moment(e).isValid()) {
                setRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")});
            } else {
                setRequestData({...requestData, [name] : ""});
            }
        } else if (type === "cb") {
            setRequestData({...requestData, [name] : e.target.checked});
        }
    }

    const toFirstPage = () => {
        setRequestData({...requestData, page: 1});
        setPageChanged(true);
    }

    const toPreviousPage = () => {
        setRequestData({...requestData, page: requestData.page - 1});
        setPageChanged(true);
    }

    const toNextPage = () => {
        setRequestData({...requestData, page: requestData.page + 1});
        setPageChanged(true);
    }

    const toLastPage = () => {
        setRequestData({...requestData, page: totalPages});
        setPageChanged(true);
    }

    return (
        <Modal className={"themeModalBig"} backdrop={'static'} show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Συσχέτιση Εγγραφής ({dcl?.dclId}) με Υπάρχων Παραστατικό</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col md={3}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => setRequestData({...requestData, date_from: from, date_to: to})}
                        />
                    </Col>
                    <Col md={3}>
                        <DateBox
                            name={"date_from"}
                            label={"Ημερομηνία από"}
                            selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                            onChange={(e) => handleOnChange(e, "db", "date_from")}
                            allowOtherYears={true}
                        />
                    </Col>
                    <Col md={3}>
                        <DateBox
                            name={"date_to"}
                            label={"Ημερομηνία έως"}
                            selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                            onChange={(e) => handleOnChange(e, "db", "date_to")}
                            allowOtherYears={true}
                        />
                    </Col>
                </Row>
                <Row className={"d-flex justify-content-end"}>
                    <Col md={3} className={"d-flex justify-content-end"}>
                        <Button onClick={() => fetchSales(false)} disabled={searchLoader} style={{marginTop: "20px"}}>
                            Αναζήτηση {searchLoader && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                        </Button>
                    </Col>
                </Row>
                {responseData.length > 0 ? (
                    <Row className={"mt-2"}>
                        {totalPages > 0 && (
                            <React.Fragment>
                                <Col md={3}>
                                    <div className={"text-muted"} style={{marginTop: "10px"}}>Σύνολο αποτελεσμάτων: {totalEntries}</div>
                                </Col>
                                <Col md={9}>
                                    <div className="d-flex justify-content-end mb-2">
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toFirstPage()}
                                            disabled={requestData.page === 1 || searchLoader}
                                        >
                                            {t('SalesBalanceSheet.first')}
                                        </Button>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toPreviousPage()}
                                            disabled={requestData.page === 1 || searchLoader}
                                        >
                                            {t('SalesBalanceSheet.previous')}
                                        </Button>
                                        <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                                               bg="primary">{t('SalesBalanceSheet.page')} {requestData.page} / {totalPages}</Badge>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toNextPage()}
                                            disabled={requestData.page === totalPages || searchLoader}
                                        >
                                            {t('SalesBalanceSheet.next')}
                                        </Button>
                                        <Button
                                            size={"sm"}
                                            className={"mr-1"}
                                            onClick={() => toLastPage()}
                                            disabled={requestData.page === totalPages || searchLoader}
                                        >
                                            {t('SalesBalanceSheet.last')}
                                        </Button>
                                    </div>
                                </Col>
                            </React.Fragment>
                        )}
                        <Col md={12}>
                            <table className={"simpleClassicTable mb-2 correlateSaleDclTable"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                    <col span={1} style={{width: "7%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Επιλεγμένο</th>
                                    <th>Ημερομηνία Έκδοσης</th>
                                    <th>Τύπος Παραστατικού</th>
                                    <th>Πελάτης</th>
                                    <th>Αρίθμηση</th>
                                    <th>Τρόπος Πληρωμής</th>
                                    <th>Καθαρή Αξία</th>
                                    <th>Αξία Φ.Π.Α.</th>
                                    <th>Τελική Αξία</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.map((row, idx) => (
                                    <tr key={`correlateSale-${idx}`} style={{backgroundColor: row._id === selectedSale?._id ? "#E3F2FD" : ""}} onClick={() => setSelectedSale(row._id === selectedSale?._id ? {} : row)}>
                                        <td style={{zoom: "1.2"}}><input type="checkbox" checked={row._id === selectedSale?._id} name={"selected"} readOnly={true} /></td>
                                        <td>{`${moment(row.date).format("DD/MM/YYYY")} ${row.time}`}</td>
                                        <td>{row.documentTypeName}</td>
                                        <td>{`${row.clientName} (${row.vat})`}</td>
                                        <td>{row?.preNumber && row.preNumber !== 'noprefix' ? (row.preNumber + " ") : ""}{row.number}</td>
                                        <td>{row.paymentTypeName}</td>
                                        <td>{row.totalNetValue.toFixed(2)} €</td>
                                        <td>{row.totalVatValue.toFixed(2)} €</td>
                                        <td>{row.totalAmount.toFixed(2)} €</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                ) : (
                    <React.Fragment></React.Fragment>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>
                    Κλείσιμο
                </Button>
                <Button disabled={loader || isEmpty(selectedSale?._id)} variant="primary" onClick={() => correlateDcl()}>
                    Συσχέτιση Εγγραφής
                    {loader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                            aria-hidden="true"></span>)}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CorrelateDclSaleModal;
